import { getDeferedLogin } from '@catalogo/service-americanas-login/src/queries/defer.graphql';
import { useQuery } from '@apollo/client';

export const useDeferedHook = ({ recsPositions, pageType = 'home' }) => {
  const { data, loading } = useQuery(getDeferedLogin, {
    variables: { recPlacements: recsPositions, pageType },
    ssr: false,
  });

  return { data, loading };
};
